export enum VatRate {
  ZERO = '0%',
  STANDARD = '20%',
}
